export const exportToCsv = (data, columns, filename) => {
    const csvRows = [];
    const headers = columns.map(col => col.label);
    csvRows.push(headers.join(','));

    for (const row of data) {
        const values = columns.map(col => {
            let val = row[col.key];
            if (val === null || val === undefined) {
                val = '';
            }
            val = String(val).replace(/"/g, '""');
            if (val.search(/("|,|\n)/g) >= 0) {
                val = `"${val}"`;
            }
            return val;
        });
        csvRows.push(values.join(','));
    }

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};


const getMonthYear = (dateString) => {
    const date = new Date(dateString);
    return `${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
};


export const glowClassMap = {
    'bg-indigo-700': 'theme-indigo',
    'bg-blue-700':   'theme-blue',
    'bg-blue-600':   'theme-blue-600',
    'bg-blue-900':   'theme-blue-900',
    'bg-purple-700': 'theme-purple',
    'bg-green-700':  'theme-green',
    'bg-pink-700':   'theme-pink',
    'bg-gray-700':   'theme-gray',
};


export const processData = (rawData) => {
    // 1. Processamento de Usuários e Atividade
    const userMap = new Map();
    rawData.users.forEach(u => userMap.set(u.id, {
        ...u,
        uploads: 0,
        approvals: 0,
        feedbacks: 0,
        workspacesCount: 0, // NOVO: Contagem de workspaces
        activeServicesCount: 0, // NOVO: Contagem de serviços ativos
        lastExamDate: 'N/A',
        dateJoined: new Date(u.date_joined).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
    }));

    // 2. Processamento de Exames e Atividade Mensal
    const examsByMonth = {};
    const examsByServiceCount = {
        CCT: 0,
        CXR: 0,
        DO: 0,
        MAMMO: 0,
        MSKXR: 0,
    };
    const examStatusCounts = { Sucesso: 0, Processando: 0, Erro: 0 };
    const funnelCounts = {
        Uploads: 0,
        'Não visualizados': 0,
        Visualizados: 0,
        Aprovados: 0,
        Editados: 0,
        Feedbacks: 0
    };

    rawData.exams.forEach(exam => {
        if (exam.uploaded_by === null || exam.uploaded_by === undefined) return;

        // Mapeamento de Status
        let status = 'Erro';
        if (exam.job_status === 'Viewer OK' || exam.job_status === 'Reported Success') {
            status = 'Sucesso';
        } else if (exam.job_status === 'Processing') {
            status = 'Processando';
        }
        examStatusCounts[status]++;

        // Contagem por Tipo de Serviço (srvc_name)
        const srvcName = (exam.srvc_name || 'Desconhecido').toUpperCase();
        examsByServiceCount[srvcName] = (examsByServiceCount[srvcName] || 0) + 1;

        // Contagem de Uploads por Mês
        const monthKey = exam.created_at.substring(0, 7); // YYYY-MM
        examsByMonth[monthKey] = (examsByMonth[monthKey] || 0) + 1;

        // Contagem de Funil
        funnelCounts.Uploads++;
        if (exam.job_status === 'Viewer OK') {
            if (exam.report_status === 'Visualizado' || exam.report_status === 'Editado' || exam.approved_by) {
                funnelCounts.Visualizados++;
            }
            if (exam.report_status === 'Editado') {
                funnelCounts.Editados++;
            }
            if (exam.approved_by) {
                funnelCounts.Aprovados++;
            }
            if (exam.has_feedback) {
                funnelCounts.Feedbacks++;
            }
            if ((exam.report_status === 'Não visualizado') || (exam.report_status === '')) {
                funnelCounts['Não visualizados']++;
            }
        }

        // Atualizar métricas do usuário
        if (exam.uploaded_by && userMap.has(exam.uploaded_by)) {
            const user = userMap.get(exam.uploaded_by);
            user.uploads++;
            // Atualizar data do último exame
            const currentExamDate = new Date(exam.created_at);
            if (user.lastExamDate === 'N/A' || currentExamDate > new Date(user.lastExamDate)) {
                user.lastExamDate = exam.created_at;
            }
        }
        if (exam.approved_by && userMap.has(exam.approved_by)) {
            userMap.get(exam.approved_by).approvals++;
        }
        if (exam.has_feedback && exam.uploaded_by && userMap.has(exam.uploaded_by)) {
            userMap.get(exam.uploaded_by).feedbacks++;
        }
    });

    // 3. Processamento de Crescimento (Mensal e Acumulado)
    const usersByJoinDate = {};
    const workspacesByCreationDate = {};
    const servicesByCreationDate = {};

    rawData.users.forEach(u => {
        const monthKey = u.date_joined.substring(0, 7);
        usersByJoinDate[monthKey] = (usersByJoinDate[monthKey] || 0) + 1;
    });

    rawData.workspaces.forEach(w => {
        const monthKey = w.created_at.substring(0, 7);
        workspacesByCreationDate[monthKey] = (workspacesByCreationDate[monthKey] || 0) + 1;
    });

    rawData.services.forEach(s => {
        const monthKey = s.created_at.substring(0, 7);
        servicesByCreationDate[monthKey] = (servicesByCreationDate[monthKey] || 0) + 1;
    });

    // 4. Métricas de Usuário/Workspace/Serviço (NOVO)
    const uniqueWorkspacesByUser = new Map();
    const activeServicesByUser = new Map();

    rawData.services.forEach(s => {
        // Contagem de Workspaces únicos por Usuário
        if (userMap.has(s.user)) {
            if (!uniqueWorkspacesByUser.has(s.user)) {
                uniqueWorkspacesByUser.set(s.user, new Set());
            }
            uniqueWorkspacesByUser.get(s.user).add(s.workspace);
        }

        // Contagem de Serviços Ativos por Usuário
        if (s.is_active && userMap.has(s.user)) {
            activeServicesByUser.set(s.user, (activeServicesByUser.get(s.user) || 0) + 1);
        }
    });

    // Integração das métricas NOVO no userMap
    Array.from(userMap.values()).forEach(user => {
        user.workspacesCount = uniqueWorkspacesByUser.get(user.id)?.size || 0;
        user.activeServicesCount = activeServicesByUser.get(user.id) || 0;
        user.createdFilters = rawData.filters.filter(f => f.user === user.id).length;

        // Finalizar formatação da data do último exame
        if (user.lastExamDate !== 'N/A') {
            user.lastExamDateFormatted = new Date(user.lastExamDate).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        } else {
            user.lastExamDateFormatted = 'N/A';
        }
    });

    // Geração de dados acumulados para gráficos de crescimento
    const allMonths = Array.from(new Set([
        ...Object.keys(examsByMonth),
        ...Object.keys(usersByJoinDate),
        ...Object.keys(workspacesByCreationDate),
        ...Object.keys(servicesByCreationDate),
    ])).sort();

    let cumulativeUsers = 0;
    let cumulativeWorkspaces = 0;
    let cumulativeServices = 0;
    const monthlyActivity = {
        uploads: allMonths.map(month => ({ month: getMonthYear(month), count: examsByMonth[month] || 0 })),
        users: allMonths.map(month => {
            cumulativeUsers += (usersByJoinDate[month] || 0);
            return { month: getMonthYear(month), count: cumulativeUsers };
        }),
        workspaces: allMonths.map(month => {
            cumulativeWorkspaces += (workspacesByCreationDate[month] || 0);
            return { month: getMonthYear(month), count: cumulativeWorkspaces };
        }),
        services: allMonths.map(month => {
            cumulativeServices += (servicesByCreationDate[month] || 0);
            return { month: getMonthYear(month), count: cumulativeServices };
        }),
    };

    // Outras Métricas e Listas
    const activeWorkspaces = rawData.workspaces.filter(w => w.is_active).length;
    const canUploadWorkspaces = rawData.workspaces.filter(w => w.can_upload).length;
    const activePermissions = rawData.services.filter(s => s.is_active).length;
    const uploadPermissions = rawData.services.filter(s => s.can_upload).length;

    const serviceUsageCounts = {};
    rawData.services.filter(s => s.is_active).forEach(s => {
        serviceUsageCounts[s.service.toUpperCase()] = (serviceUsageCounts[s.service.toUpperCase()] || 0) + 1;
    });

    const serviceList = rawData.services.map(s => {
        const userName = rawData.users.find(u => u.id === s.user)?.username || 'N/A';
        const workspaceName = rawData.workspaces.find(w => w.id === s.workspace)?.name || 'N/A';
        return {
            ...s,
            userName,
            workspaceName,
            createdAt: new Date(s.created_at).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
        };
    });

    const lastDay = new Date(Date.now() - 1 * 24 * 60 * 60 * 1000)
    const lastWeek = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)
    const lastMonth = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)

    return {
        // Métricas de Cards (Visão Geral)
        totalUsers: rawData.users.length,
        usersOn: rawData.users.filter(u => u.is_active).length,
        totalExams: rawData.exams.filter(e => e.uploaded_by !== null && e.uploaded_by !== undefined).length,
        totalWorkspaces: rawData.workspaces.length,
        totalFeedbacks: rawData.exams.filter(e => e.has_feedback && e.uploaded_by !== null && e.uploaded_by !== undefined).length,
        examsByServiceCount,
        activeUsers: {
            daily: rawData.users.filter(user => new Date(user.last_login) >= lastDay).length,
            weekly: rawData.users.filter(user => new Date(user.last_login) >= lastWeek).length,
            monthly: rawData.users.filter(user => new Date(user.last_login) >= lastMonth).length,
        },

        // Dados de Tabela
        userList: Array.from(userMap.values()),
        workspaceList: rawData.workspaces.map(w => {
            const ownerName = rawData.users.find(u => u.id === w.owner)?.username || 'N/A';
            const usersInWorkspace = rawData.services.filter(s => s.workspace === w.id).map(s => s.user);
            const uniqueUsersInWorkspace = Array.from(new Set(usersInWorkspace));
            return {
                ...w,
                ownerName,
                userCount: uniqueUsersInWorkspace.length,
                usersInWorkspace: uniqueUsersInWorkspace.map(userId => userMap.get(userId) || { username: 'ID Desconhecido' }), // Detalhe de usuários
                createdAt: new Date(w.created_at).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
            };
        }),
        serviceList,
        examList: rawData.exams.map(e => ({
            ...e,
            uploader: rawData.users.find(u => u.id === e.uploaded_by)?.username || '',
            approver: rawData.users.find(u => u.id === e.approved_by)?.username || '',
            reportId: e.report_id || 'N/A',
            createdAt: new Date(e.created_at).toLocaleDateString('pt-BR', { timeZone: 'UTC' }),
        })),

        // Dados para Gráficos
        examStatusData: Object.entries(examStatusCounts).map(([label, count]) => ({ label, count })),
        monthlyActivity,
        funnelCounts,
        serviceUsageCounts,

        // Métricas
        activeWorkspaces,
        canUploadWorkspaces,
        activePermissions,
        uploadPermissions,
    };
};
